var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{on:{"click":function($event){$event.preventDefault();return _vm.downloadCSVData()}}},[_vm._v("Download Custom Scenario Data (csv)")])])}
var staticRenderFns = []

export { render, staticRenderFns }